/**
 * Constants for display index calculation
 */

export const gap =
  process.env.NODE_ENV === 'production'
    ? 1_000_000 // 1 million
    : // use 1000 in test/dev
      1000

export const dayRangeSize = gap * 100 // 100 million per day (or 100,000 in test mode)
export const baseDate = 19700101 // Base date for offset calculation (offset = 0)
export const defaultReminderTime = 24 * 60 * 60 // midnight in seconds
